import type { ReactNode } from 'react';
import clsx from 'clsx';
import './BayAttentionBanner.scss';

interface BayAttentionBannerProps {
	description?: string | ReactNode;
	variant?: string;
	externalLinkText?: string;
	onExternalLinkClick?: () => void;
	isBold?: boolean;
}

const BayAttentionBanner = ({
	description = 'Bay Attention Banner',
	variant = 'info',
	externalLinkText,
	onExternalLinkClick,
	isBold = true,
}: BayAttentionBannerProps) => {
	return (
		<div className={`rounded-2 bay-attention-banner-${variant}`}>
			<p className={clsx('px-4 py-3', { 'fw-bold': isBold })}>
				{typeof description === 'string' && description.includes('externalLinkText') && externalLinkText ? (
					<>
						{description.split('externalLinkText').map((desc, index) => {
							if (index === 0) {
								return <span key={index}>{desc}</span>;
							} else {
								return (
									<span key={index}>
										<span
											className="text-decoration-underline cursor-pointer"
											onClick={onExternalLinkClick}
										>
											{externalLinkText}
										</span>
										{desc}
									</span>
								);
							}
						})}
					</>
				) : (
					description
				)}
			</p>
		</div>
	);
};

export default BayAttentionBanner;
